import { gsap, SplitText, ScrollTrigger } from '../global/gsap';

const initStatements = (statements) => {
    statements.forEach(statement => {
        const initText = statement.querySelector('.js-statement-init')
        const revealText = statement.querySelector('.js-statement-reveal');

        const initSplit = new SplitText(initText, { type: 'chars' });
        const revealSplit = new SplitText(revealText, { type: 'chars' });

        const revealTl = gsap.timeline({defaults: {
            ease: 'power3.inOut',
            duration: .3
        }});

        revealTl.pause();

        gsap.set(revealSplit.chars, { opacity: 0, yPercent: 100 });

        revealTl.to(initSplit.chars, {autoAlpha: 0, yPercent: -100, stagger: .025});
        revealTl.to(revealSplit.chars, {yPercent: 0, autoAlpha: 1, stagger: .025}, '<');

        statement.addEventListener('mouseenter', () => {
            revealTl.play();
        })

        statement.addEventListener('mouseleave', () => {
            revealTl.reverse();
        })
    });
}

export default initStatements;